import { type RefObject, useCallback, useRef } from 'react';

function getCursorHoverables(): HTMLElement[] {
	return Array.from(
		document.querySelectorAll<HTMLElement>('[data-cursor-hoverable]')
	);
}

interface UseCursorCollisionReturnType {
	hoveredRef: RefObject<Nullable<HTMLElement>>;

	update: (x: number, y: number) => Nullable<HTMLElement>;
}

export function useCursorCollision(): UseCursorCollisionReturnType {
	const hoveredRef = useRef<Nullable<HTMLElement>>(null);

	const update = useCallback(
		(mx: number, my: number): Nullable<HTMLElement> => {
			const nodes = getCursorHoverables();

			let matchedNode: Nullable<HTMLElement> = null;

			for (const node of nodes) {
				const r = node.getBoundingClientRect();

				if (mx >= r.left && mx <= r.right && my >= r.top && my <= r.bottom) {
					matchedNode = node;
					break;
				}
			}

			hoveredRef.current = matchedNode;

			return matchedNode;
		},
		[]
	);

	return { hoveredRef, update };
}
